import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import config from "../config";
import AdminShell, { d8 } from "./AdminShell";

const API = config.API_BASE_URL;

// Ενιαία εικόνα υπηρεσιών ανά προϊόν, παραγόμενη από τα δεδομένα των πελατών.
export default function AdminProducts() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/companies`).then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return <AdminShell><div className="ad-empty">…</div></AdminShell>;

  const core = data.companies.filter((c) => c.corePlan);
  const byProduct = new Map();
  for (const c of data.companies) {
    for (const p of c.products) {
      if (!byProduct.has(p.product_code)) byProduct.set(p.product_code, []);
      byProduct.get(p.product_code).push({ company: c, p });
    }
  }
  const labels = { estiasync_buzz: "EstiaSync Buzz", ordering: "EstiaSync Ordering" };

  return (
    <AdminShell>
      <div className="ad-grid" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))" }}>
        <div className="ad-card">
          <h3>EstiaSync ({t("core product")})</h3>
          {core.length === 0 && <div className="ad-hint">{t("No active subscriptions.")}</div>}
          {core.map((c) => (
            <div key={c.id} style={{ marginBottom: 6 }}>
              <strong style={{ fontSize: 13 }}>{c.name}</strong>{" "}
              <span className="ad-chip active">{c.corePlan.plan}</span>
              <div className="ad-hint">{t("Until")}: {d8(c.corePlan.ends)}</div>
            </div>
          ))}
        </div>

        {[...byProduct.entries()].map(([code, rows]) => (
          <div className="ad-card" key={code}>
            <h3>{labels[code] || code}</h3>
            {rows.map(({ company, p }) => (
              <div key={company.id} style={{ marginBottom: 6 }}>
                <strong style={{ fontSize: 13 }}>{company.name}</strong>{" "}
                <span className={`ad-chip ${p.status}`}>{t(p.status)}</span>
                <div className="ad-hint">
                  {p.billing_period === "yearly" ? t("yearly") : t("monthly")}
                  {p.table_quota ? ` · ${p.table_quota} ${t("tables")}` : ""}
                  {p.trial_ends_at ? ` · ${t("Trial ends")}: ${d8(p.trial_ends_at)}` : ""}
                  {p.renewal_date ? ` · ${t("Renewal")}: ${d8(p.renewal_date)}` : ""}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </AdminShell>
  );
}
